
export type GetTweetsSortBy = typeof GetTweetsSortBy[keyof typeof GetTweetsSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetsSortBy = {
  createdAt: 'createdAt',
  likeCount: 'likeCount',
  retweetCount: 'retweetCount',
  viewCount: 'viewCount',
} as const;
